/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-survey.reducer';

export const PatientSurveyDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientSurveyEntity = useAppSelector(state => state.patientSurvey.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientSurveyDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientSurvey.detail.title">PatientSurvey</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientSurvey.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientSurveyEntity.id}</dd>
          <dt>
            <span id="completedOn">
              <Translate contentKey="tinyMedicRestApp.patientSurvey.completedOn">Completed On</Translate>
            </span>
          </dt>
          <dd>
            {patientSurveyEntity.completedOn ? (
              <TextFormat value={patientSurveyEntity.completedOn} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="completedByType">
              <Translate contentKey="tinyMedicRestApp.patientSurvey.completedByType">Completed By Type</Translate>
            </span>
          </dt>
          <dd>{patientSurveyEntity.completedByType}</dd>
          <dt>
            <span id="completedById">
              <Translate contentKey="tinyMedicRestApp.patientSurvey.completedById">Completed By Id</Translate>
            </span>
          </dt>
          <dd>{patientSurveyEntity.completedById}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientSurvey.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientSurveyEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientSurvey.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientSurveyEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientSurvey.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientSurveyEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientSurvey.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientSurveyEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientSurvey.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientSurveyEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientSurvey.survey">Survey</Translate>
          </dt>
          <dd>{patientSurveyEntity.survey ? patientSurveyEntity.survey.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientSurvey.patient">Patient</Translate>
          </dt>
          <dd>{patientSurveyEntity.patient ? patientSurveyEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-survey" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-survey/${patientSurveyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientSurveyDetail;
